import { Auth } from 'aws-amplify';

import { userFields } from '../../../../airtable/metadata/users';
import { fetchUI } from '../../../../airtable/settings';
import { createUser, findUser } from '../../../../airtable/users';

import { store } from './memory';

export async function changePassword({ currentPassword, password }) {
  const cognito = await getCognito();
  const response = await Auth.changePassword(cognito, currentPassword, password);
  console.log('[auth] changePassword:', response);
}

export async function reset({ email }) {
  const response = await Auth.forgotPassword(email);
  console.log('[auth] reset:', response);
}

export async function confirmReset({ code, email, password }) {
  const response = await Auth.forgotPasswordSubmit(email, code, password);
  console.log('[auth] confirmReset:', response);

  return signIn({ email, password });
}

export async function signIn({ email, password }) {
  const response = await Auth.signIn(email, password);
  console.log('[auth] signIn:', response);

  const user = await getUser();
  const airtable = await findUser(email);

  if (!airtable) {
    await createUser({
      fields: {
        [userFields.EMAIL]: user.email,
        [userFields.USER_NAME]: user.name,
      },
    });
  }

  return response;
}

export async function signOut() {
  const response = await Auth.signOut();
  console.log('[auth] signOut:', response);
}

export async function signUp({ email, name, password }) {
  const response = await Auth.signUp({
    username: email,
    password,
    attributes: {
      name,
    },
  });
  console.log('[auth] signUp:', response);

  return response;
}

export async function confirmSignUp({ code, email }) {
  const response = await Auth.confirmSignUp(email, code);
  console.log('[auth] confirmSignUp:', response);

  return response;
}

export async function resendSignUp({ email }) {
  const response = await Auth.resendSignUp(email);
  console.log('[auth] resendSignUp:', response);

  return response;
}

export async function getCognito() {
  try {
    const cognito = await Auth.currentAuthenticatedUser();
    console.log('[auth] getCognito:', cognito);

    return cognito;
  } catch (error) {
    console.log('[auth] getCognito:', error);
    return undefined;
  }
}

export async function getUser() {
  try {
    const cognito = await getCognito();
    const { email, name } = cognito.attributes;

    const airtable = await findUser(email);

    const user = {
      airtable,
      email,
      name,
    };

    store(await fetchUI(user));

    console.log('[auth] getUser:', user);
    return user;
  } catch (error) {
    console.log('[auth] getUser:', error);
    return undefined;
  }
}
